export default "__VITE_ASSET__7302b155__"